import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { DataRequest } from '@eggplant/data-request'
import type { AiStatusResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: AiStatusResponse) => ReactElement
}

const GetUnauthenticatedAiStatusRequest = ({
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/status`

  return (
    <DataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetUnauthenticatedAiStatusRequest
